import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Button, rem } from '@mantine/core'

export const StyledHomeCommunityButton = styled(Button)<any>`
  &.homeCommunityButton {
    border-color: ${theme.colors.teal600};
    color: ${theme.colors.teal600};
  }

  &.homeCommunityButtonJoin {
    width: 100%;
    background-color: ${theme.colors.blue50};
    color: ${theme.colors.primaryBase};
    transition: 0.2s linear all;
    &:hover {
      color: white;
    }
    img {
      width: 100%;
      height: 100%;
    }

    .mantine-Button-icon {
      font-size: ${rem(18)};
    }

    &.joined {
      color: ${theme.colors.green600};
      background-color: ${theme.colors.neutral50};
    }
  }

  &.homeCommunityButtonAI {
    padding-block: 0;
    padding-inline: 0;
    padding-left: ${rem(16)};
    padding-right: ${rem(6)};
    background: radial-gradient(
      128.19% 284.88% at 128.19% -20.37%,
      #2d87f3 0%,
      #7fe4de 28.94%,
      #bcdeff 63.9%,
      #e3f2ff 100%
    );
    color: ${theme.colors.gray800};
    font-size: ${rem(14)};
    font-weight: 400;
    line-height: ${rem(22)};
    max-width: 100%;
    overflow: hidden;
    cursor: default;
    pointer-events: none;

    .mantine-Button-inner {
      justify-content: space-between;
    }

    .mantine-Button-label {
      span {
        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .mantine-Button-rightIcon {
      margin-left: ${rem(24)};
      display: flex;
      height: 100%;
      align-items: flex-end;
    }
  }

  ${MediaQueries.lgPcDown} {
    &.homeCommunityButtonAI {
      .mantine-Button-rightIcon {
        margin-left: ${rem(20)};
      }
    }
  }

  ${MediaQueries.tdDown} {
    &.homeCommunityButtonAI {
      .mantine-Button-rightIcon {
        margin-left: ${rem(16)};
      }
    }
  }

  ${MediaQueries.smbDown} {
    &.homeCommunityButton,
    &.homeCommunityButtonAI {
      width: 100%;
    }

    &.homeCommunityButtonAI {
      .mantine-Button-rightIcon {
        margin-left: ${rem(4)};
      }
    }
  }
`
